import { useState } from 'react';

interface CodeBlockProps {
    code: string;
    language?: string;
}

const CodeBlock = ({ code, language = 'tsx' }: CodeBlockProps) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (error) {
            console.error('Failed to copy code snippet', error);
        }
    };

    return (
        <div className="code-block">
            <div className="code-block-header">
                <span className="code-block-lang">{language}</span>
                <button className="code-block-copy" onClick={handleCopy} type="button">
                    {copied ? 'Copied' : 'Copy'}
                </button>
            </div>
            <pre>
                <code>{code}</code>
            </pre>
        </div>
    );
};

export default CodeBlock;
